import { createContext, useState } from 'react';

import OmeMeetOrgUnitContactData from './OmeMeetOrgUnitContactData';

export const OmeMeetOrgUnitContactStateContext = createContext();

const OmeMeetOrgUnitContactContextProvider = ({ children }) => {
  const stateHook = useState(OmeMeetOrgUnitContactData.INITIAL_STATE);

  return (
    <OmeMeetOrgUnitContactStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetOrgUnitContactStateContext.Provider>
  );
};

export default OmeMeetOrgUnitContactContextProvider;